'use client';
import React, { useState } from 'react';
import { AlertOctagon, FileMinus, Clock, CreditCard, FileSearch, Layers, CheckCircle } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const alertCategories = [
  { label: 'Critiques', count: 7, icon: AlertOctagon, color: '#C0392B', bg: '#FDEDEC' },
  { label: 'Titres Expirés', count: 34, icon: FileMinus, color: '#E67E22', bg: '#FEF5E7' },
  { label: 'Délais Dépassés', count: 23, icon: Clock, color: '#C0392B', bg: '#FDEDEC' },
  { label: 'Paiements Retard', count: 18, icon: CreditCard, color: '#D4AC0D', bg: '#FEF9E7', subLabel: '(Recettes et dépenses)' },
  { label: 'Dossiers Incomplets', count: 45, icon: FileSearch, color: '#1B4F72', bg: '#EBF5FB' },
  { label: 'Empiètements GIS', count: 5, icon: Layers, color: '#8E44AD', bg: '#F5EEF8' },
];

const alertsData = [
  { id: 'ALT-001', niveau: 'critique', module: 'Titres Miniers', description: 'Titre PE-0078-2018 expiré depuis 150 jours — aucune action entreprise', date: '04/06/2024 08:30', assigneA: 'Agent Mwamba', statut: 'Ouvert' },
  { id: 'ALT-002', niveau: 'critique', module: 'Requêtes', description: 'REQ-2024-0892 — délai légal dépassé de 15 jours, risque contentieux', date: '03/06/2024 14:15', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-003', niveau: 'warning', module: 'Finance', description: 'Congo Copper Corp — Frais de demande de renouvellement AECP/Titre impayés depuis 45 jours (120 000 $)', date: '03/06/2024 09:00', assigneA: 'Comptable Mutombo', statut: 'En cours' },
  { id: 'ALT-004', niveau: 'critique', module: 'GIS', description: 'Empiètement détecté entre PE-0156-2023 et PE-0201-2021 — zone Katanga', date: '02/06/2024 16:45', assigneA: 'Cartographe Kabila', statut: 'En cours' },
  { id: 'ALT-005', niveau: 'warning', module: 'Titres Miniers', description: 'PE-G-0003-2022 expire dans 45 jours — renouvellement non initié', date: '02/06/2024 11:20', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-006', niveau: 'info', module: 'Qualité', description: 'Dossier REQ-2024-0900 incomplet — 3 documents manquants', date: '01/06/2024 15:30', assigneA: 'Agent Mwamba', statut: 'Ouvert' },
  { id: 'ALT-007', niveau: 'critique', module: 'Finance', description: 'Taux de recouvrement mensuel en dessous du seuil critique (62% vs 80% attendu)', date: '01/06/2024 08:00', assigneA: 'DG Mukendi', statut: 'En cours' },
  { id: 'ALT-008', niveau: 'warning', module: 'Requêtes', description: 'REQ-2024-0896 — documents non conformes, relance nécessaire', date: '31/05/2024 14:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-009', niveau: 'info', module: 'Titres Miniers', description: 'PR-0145-2018 expiré — archivage requis selon procédure', date: '30/05/2024 10:15', assigneA: 'Agent Mwamba', statut: 'Résolu' },
  { id: 'ALT-010', niveau: 'critique', module: 'Litiges', description: 'Audience judiciaire dans 3 jours — dossier Kibali vs État, aucun avocat assigné', date: '30/05/2024 09:00', assigneA: 'Juriste Lukusa', statut: 'En cours' },
  { id: 'ALT-011', niveau: 'warning', module: 'Finance', description: 'Frais de demande d\'octroi d\'une ARPC/Carré — paiement en attente depuis 30 jours', date: '28/05/2024 10:00', assigneA: 'Comptable Mutombo', statut: 'Ouvert' },
  { id: 'ALT-012', niveau: 'warning', module: 'Finance', description: 'Frais de demande de cession AECP/Titre — dossier Katanga Minerals en retard de paiement', date: '27/05/2024 09:30', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-013', niveau: 'warning', module: 'Finance', description: 'Frais de demande de cession PE/Titre — Congo Copper Corp, 60 jours de retard', date: '26/05/2024 14:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-014', niveau: 'warning', module: 'Finance', description: 'Frais de demande de cession PE/Titre PARTIELLE — Nord-Kivu Minerals, paiement non reçu', date: '25/05/2024 11:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-015', niveau: 'warning', module: 'Finance', description: 'Frais de demande de cession PER/Titre — Maniema Resources, relance nécessaire', date: '24/05/2024 10:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-016', niveau: 'warning', module: 'Finance', description: 'Frais de demande de cession PR/Titre — Lomami Mining Group, 45 jours impayés', date: '23/05/2024 09:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-017', niveau: 'warning', module: 'Finance', description: 'Frais de demande de renouvellement PER/Titre — Kibali Gold SA, échéance dépassée', date: '22/05/2024 08:30', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-018', niveau: 'info', module: 'Finance', description: 'Frais de demande de transformation d\'ARPC en AECP — dossier en attente de régularisation', date: '21/05/2024 14:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-019', niveau: 'info', module: 'Finance', description: 'Frais de demande de transformation de PEPM en PE — paiement partiel reçu', date: '20/05/2024 11:00', assigneA: 'Comptable Mutombo', statut: 'En cours' },
  { id: 'ALT-020', niveau: 'info', module: 'Finance', description: 'Frais de demande de transformation de PR en PE — dossier incomplet, documents manquants', date: '19/05/2024 10:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-021', niveau: 'info', module: 'Finance', description: 'Frais de demande de transformation de PR en PEPM — en attente de confirmation', date: '18/05/2024 09:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-022', niveau: 'info', module: 'Finance', description: 'Frais de dépôt complémentaire à l\'Avis de Confirmation de Recevabilité des EIES-PGES — non réglé', date: '17/05/2024 14:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-023', niveau: 'info', module: 'Finance', description: 'Frais de dépôt de mise à jour EIES/PGES — paiement attendu depuis 20 jours', date: '16/05/2024 10:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-024', niveau: 'info', module: 'Finance', description: 'Frais de dépôt de mise à jour des études de faisabilité — dossier en attente', date: '15/05/2024 09:00', assigneA: 'Non assigné', statut: 'Ouvert' },
  { id: 'ALT-025', niveau: 'info', module: 'Finance', description: 'Frais de dépôt du PAR/Titre — régularisation requise avant clôture du trimestre', date: '14/05/2024 08:00', assigneA: 'Non assigné', statut: 'Ouvert' },
];

const niveauConfig: Record<string, { bg: string; color: string; label: string }> = {
  critique: { bg: '#FDEDEC', color: '#C0392B', label: 'Critique' },
  warning: { bg: '#FEF5E7', color: '#E67E22', label: 'Avertissement' },
  info: { bg: '#EBF5FB', color: '#1B4F72', label: 'Information' },
};

const statutConfig: Record<string, { bg: string; color: string }> = {
  'Ouvert': { bg: '#FDEDEC', color: '#C0392B' },
  'En cours': { bg: '#FEF5E7', color: '#E67E22' },
  'Résolu': { bg: '#EAFAF1', color: '#1E8449' },
};

export default function CentreAlertes() {
  const [filterNiveau, setFilterNiveau] = useState('Tous');
  const [filterModule, setFilterModule] = useState('Tous');
  const [alerts, setAlerts] = useState(alertsData);
  const [assignModal, setAssignModal] = useState<string | null>(null);
  const [assignValue, setAssignValue] = useState('');

  const filtered = alerts.filter(a => {
    const matchNiveau = filterNiveau === 'Tous' || a.niveau === filterNiveau;
    const matchModule = filterModule === 'Tous' || a.module === filterModule;
    return matchNiveau && matchModule;
  });

  const handleResolve = (id: string) => {
    setAlerts(prev => prev.map(a => a.id === id ? { ...a, statut: 'Résolu' } : a));
  };

  const handleAssign = (id: string) => {
    if (assignValue.trim()) {
      setAlerts(prev => prev.map(a => a.id === id ? { ...a, assigneA: assignValue, statut: 'En cours' } : a));
      setAssignModal(null);
      setAssignValue('');
    }
  };

  const modules = ['Tous', ...Array.from(new Set(alertsData.map(a => a.module)))];

  return (
    <div className="p-4 lg:p-6 space-y-5">
      {/* Assign Modal */}
      {assignModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
            <h3 className="font-bold text-gray-800 mb-4">Assigner l'alerte {assignModal}</h3>
            <input
              type="text"
              placeholder="Nom de l'agent..."
              value={assignValue}
              onChange={e => setAssignValue(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 text-sm outline-none mb-4"
              style={{ borderColor: '#e5e7eb' }}
            />
            <div className="flex gap-2">
              <button
                onClick={() => handleAssign(assignModal)}
                className="flex-1 py-2 rounded-lg text-sm font-semibold text-white"
                style={{ background: '#1B4F72' }}
              >
                Assigner
              </button>
              <button
                onClick={() => setAssignModal(null)}
                className="flex-1 py-2 rounded-lg text-sm font-semibold text-gray-600 border"
                style={{ borderColor: '#e5e7eb' }}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Category counters */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {alertCategories.map((cat, i) => {
          const Icon = cat.icon;
          return (
            <div key={i} className="bg-white rounded-xl border p-4 cursor-pointer hover:shadow-md transition-all" style={{ borderColor: '#e5e7eb' }}>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center mb-2" style={{ background: cat.bg }}>
                <Icon size={16} style={{ color: cat.color }} />
              </div>
              <p className="text-2xl font-bold" style={{ color: cat.color }}>{cat.count}</p>
              <p className="text-xs text-gray-500 mt-0.5">{cat.label}</p>
              {cat.subLabel && <p className="text-xs mt-0.5" style={{ color: cat.color }}>{cat.subLabel}</p>}
            </div>
          );
        })}
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl border p-3 flex flex-wrap gap-3" style={{ borderColor: '#e5e7eb' }}>
        <select
          value={filterNiveau}
          onChange={e => setFilterNiveau(e.target.value)}
          className="border rounded-lg px-3 py-2 text-sm text-gray-700 outline-none"
          style={{ borderColor: '#e5e7eb' }}
        >
          <option value="Tous">Tous les niveaux</option>
          <option value="critique">Critique</option>
          <option value="warning">Avertissement</option>
          <option value="info">Information</option>
        </select>
        <select
          value={filterModule}
          onChange={e => setFilterModule(e.target.value)}
          className="border rounded-lg px-3 py-2 text-sm text-gray-700 outline-none"
          style={{ borderColor: '#e5e7eb' }}
        >
          {modules.map(m => <option key={m} value={m}>{m === 'Tous' ? 'Tous les modules' : m}</option>)}
        </select>
        <span className="ml-auto text-xs text-gray-400 self-center">{filtered.length} alertes</span>
      </div>

      {/* Alerts list */}
      <div className="space-y-3">
        {filtered.map((alert) => {
          const nc = niveauConfig[alert.niveau];
          const sc = statutConfig[alert.statut] || { bg: '#F4F6F8', color: '#7F8C8D' };
          return (
            <div
              key={alert.id}
              className="bg-white rounded-xl border p-4 flex gap-4"
              style={{ borderColor: alert.niveau === 'critique' ? '#C0392B' : '#e5e7eb', borderWidth: alert.niveau === 'critique' ? 2 : 1 }}
            >
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: nc.bg }}
              >
                <AlertOctagon size={18} style={{ color: nc.color }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs font-mono text-gray-400">{alert.id}</span>
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: nc.bg, color: nc.color }}>
                    {nc.label}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: '#F4F6F8', color: '#7F8C8D' }}>
                    {alert.module}
                  </span>
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: sc.bg, color: sc.color }}>
                    {alert.statut}
                  </span>
                </div>
                <p className="text-sm text-gray-800 font-medium">{alert.description}</p>
                <div className="flex flex-wrap gap-3 mt-1 text-xs text-gray-400">
                  <span>{alert.date}</span>
                  <span>Assigné à: <strong className="text-gray-600">{alert.assigneA}</strong></span>
                </div>
              </div>
              {alert.statut !== 'Résolu' && (
                <div className="flex flex-col gap-2 shrink-0">
                  <button
                    onClick={() => setAssignModal(alert.id)}
                    className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white transition-opacity hover:opacity-80"
                    style={{ background: '#1B4F72' }}
                  >
                    Assigner
                  </button>
                  <button
                    onClick={() => handleResolve(alert.id)}
                    className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white transition-opacity hover:opacity-80"
                    style={{ background: '#1E8449' }}
                  >
                    Résoudre
                  </button>
                </div>
              )}
              {alert.statut === 'Résolu' && (
                <div className="shrink-0 flex items-center">
                  <CheckCircle size={20} style={{ color: '#1E8449' }} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
